import { Messages } from '../../codegen/Localize';
import { IErrorDetail } from '../../commonInfra/contentActions/ActionMessages';
import { IErrorItem } from '../../commonInfra/contentActions/MultipleItemResult';
import { CommonErrorCode, ViewErrorCode } from '../../ts/helpers/ErrorCodes';
import { L10n } from '../../ts/L10n/L10n';
import { IViewInfo } from '../../ts/models/IViewInfo';

export namespace ViewErrors {

  export function errorDetailsFor(viewErrorItem: IErrorItem<IViewInfo>): IErrorDetail {
    return {
      itemName: viewErrorItem.item.name,
      itemUrl: null,
      errorMessage: this.errorMessageFor(viewErrorItem)
    };
  }

  export function errorMessageFor(errorItem: IErrorItem<IViewInfo>) {
    const view = errorItem.item;
    switch (errorItem.error.code) {
      case CommonErrorCode.ViewNotFound:
        return Messages.errorViewNotFound({ VIEW_NAME: L10n.elideIfLong(view.name) });
      case CommonErrorCode.CallingUserInsufficientPermissions:
        return Messages.errorViewInsufficientPermissions();
      case ViewErrorCode.ViewNameAlreadyExists:
        return Messages.errorViewNameAlreadyExists();

      default:
        return Messages.errorUnknown();
    }
  }

}
